import axios from 'axios';
import Config from '../../../../settings/urbanice-api'
import { siteConfig } from "../../../../settings";
const AUTH_BASIC = process.env.REACT_APP_AUTH_BASIC;

const DEBUG = siteConfig.DEBUG
const GRANT_ACCESS_TOKEN_V2 = Config.GRANT_ACCESS_TOKEN_V2;
const CHECK_EXIST_USER_ID = Config.CHECK_EXIST_USER_ID; //<== Deprecate
const CHECK_EXIST_ACCOUNT_INDENTITY = Config.CHECK_EXIST_ACCOUNT_INDENTITY;
const GET_USER_INFO = Config.GET_USER_INFO;
const GET_USER_ACL = Config.GET_USER_ACL;
const GET_USER_COMMUNITY = Config.GET_USER_COMMUNITY;
const GET_COMMUNITY_FEATURE = Config.GET_COMMUNITY_FEATURE;
const UPDATE_USER_PREFERENCE = Config.UPDATE_USER_PREFERENCE;
const GET_COMMUNITY_USER_NOTIFICATION_COUNT = Config.GET_COMMUNITY_USER_NOTIFICATION_COUNT;
const GET_COMMUNITY_INFO = Config.GET_COMMUNITY_INFO;
const userToken = localStorage.getItem('access_token');

const authHeaderBasic = {
  headers: {
    "Content-Type": "application/json",
    "Authorization": 'Basic ' + AUTH_BASIC,
  }
};

const authHeaderToken = {
  headers: {
    "Content-Type": "application/json",
    "Authorization": 'Bearer ' + userToken
  }
}

const grantAccessToken = (userIdentity, idenityType, accessToken) => {
  let dataInput = {
    'grant_type': 'password',
    username: userIdentity,
    password: idenityType === 'EMAIL' ? accessToken : (idenityType === 'FACEBOOK_USER_ID' ? 'fb/' + accessToken : 'ap/' + accessToken)
  };
  return axios
    .post(GRANT_ACCESS_TOKEN_V2, dataInput, authHeaderBasic)
    .then((response) => {
      DEBUG && console.log('response', response.data)
      localStorage.setItem("userToken", JSON.stringify(response.data));
      localStorage.setItem('access_token', response.data.access_token);
      return response.data;
    })
};

const checkExistUserID = (userIdentity, idenityType) => {
  return axios
    .get(CHECK_EXIST_USER_ID, "?userIdentity=" + userIdentity + "&identityType=" + idenityType, authHeaderBasic)
    .then((response) => {
      DEBUG && console.log('response', response.data)
      return response.data;
    })
}

const checkExistAccountID = (userIdentity, idenityType) => {
  return axios
    .get(CHECK_EXIST_ACCOUNT_INDENTITY, "?userIdentity=" + userIdentity + "&identityType=" + idenityType, authHeaderBasic)
    .then((response) => {
      DEBUG && console.log('response', response.data)
      return response.data;
    })
}


const logout = () => {
  localStorage.removeItem("userToken");
};

const getUserInfo = () => {
  DEBUG && console.log(`getUserInfo`);
  return axios
    .get(GET_USER_INFO, authHeaderToken)
    .then((response) => {
      DEBUG && console.log(`getUserInfo_response`, response);
      if (response.data.isSuccess) {
        return response.data;
      } else {
        return null
      }
    })
}

const getUserCommunity = () => {
  DEBUG && console.log(`getUserCommunity`);
  const userToken = localStorage.getItem('access_token');

  return axios
    .get(GET_USER_COMMUNITY, authHeaderToken)
    .then((response) => {
      DEBUG && console.log(`getUserCommunity_response`, response);
      if (response.data.isSuccess) {
        return response.data;
      } else {
        return null
      }
    });
}

const getUserAcl = (communityID) => {
  return axios
    .get(GET_USER_ACL + "?communityID=" + communityID, authHeaderToken)
    .then((response) => {
      DEBUG && console.log(`getUserAcl_response`, response);
      if (response.data.isSuccess) {
        return response.data;
      } else {
        return null
      }
    });
}

const getCommunityFeature = (communityID) => {
  return axios
    .get(GET_COMMUNITY_FEATURE + "?communityID=" + communityID, authHeaderToken)
    .then((response) => {
      DEBUG && console.log(`getCommunityFeature_response`, response);
      if (response.data.isSuccess) {
        return response.data;
      } else {
        return null
      }
    });
}

const getCommunityInfo = (communityID) => {
  return axios
    .get(GET_COMMUNITY_INFO + "?communityID=" + communityID, authHeaderToken)
    .then((response) => {
      DEBUG && console.log(`getCommunityInfo_response`, response);
      if (response.data.isSuccess) {
        return response.data;
      } else {
        return null
      }
    });
}

const updateUserPreference = (communityID) => {
  var DATA = {
    "preferences": [
      {
        "key": "lang",
        "value": "th"
      },
      {
        "key": "current-community",
        "value": communityID,
      }]
  };

  return axios
    .put(UPDATE_USER_PREFERENCE, DATA, authHeaderToken)
    .then((response) => {
      DEBUG && console.log(`updateUserPreference_response`, response);
      if (response.data.isSuccess) {
        return response.data;
      } else {
        return null
      }
    });
}

const getCommunityUserNotificationCount = () => {
  return axios
    .get(GET_COMMUNITY_USER_NOTIFICATION_COUNT + "?entityType=PMC", authHeaderToken)
    .then((response) => {
      DEBUG && console.log(`getCommunityUserNotificationCount_response`, response);
      if (response.data.isSuccess) {
        return response.data;
      } else {
        return null
      }
    });
}


export default {
  grantAccessToken,
  checkExistUserID,
  checkExistAccountID,
  logout,
  getUserInfo,
  getUserAcl,
  getUserCommunity,
  getCommunityFeature,
  getCommunityInfo,
  updateUserPreference,
  getCommunityUserNotificationCount,
}